import { render, staticRenderFns } from "./SystemMetaTab.vue?vue&type=template&id=71bc0b5a"
import script from "./SystemMetaTab.vue?vue&type=script&lang=js"
export * from "./SystemMetaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports